import { AnaColumn } from "../forms-template.service";

export const diarioAttivitaDashBoardGrid: AnaColumn[] = [{
  // configuration:
  // {
  //   service: 'diarioAttivitaDashBoardGrid',
  //   api: 'diario',
  //   api_rest: true,
  //   filterList: 'Stato<2',
  //   filterEditor: '/$',
  //   formType: 'simple',

  //   queryFilter: [
  //     { field: 'Stato', operator: '<', value: 2 }
  //   ],
  //   idTabRif: [],
  //   costantValues: [],
  //   masterKey: 'id',
  //   nCol: 1,
  // },
  itemType: "group", colCount: "1", class: "", caption: "Diario Attività",
  data: [
    {
      type: 'buttonArray',
      dataField: "",
      hideOnEdit: false,
      width: 30,
      disabled: false,
      class: 'text-center',
      horizontalAlignment: 'center',
      colAlignment: 'center',
      buttonArray: [
        {
          event: "apriContatto",
          name: "apriContatto",
          hint: "Apri Contatto",
          icon: "bi bi-box-arrow-up-left",
          class: 'customBtnCrm'
        }
      ]
    },
    {
      type: 'campoData',
      dataType: 'date',
      dataField: 'DataInserimento',
      format: "dd/MM/yyyy",
      editorType: "dxDateBox",
      showClearButton: true,
      showDropDownButton: false,
      disabled: true,
      disableOnUpdate: true,
      readonly: true,
      colVisible: true,
      class: 'pe-none',
      caption: 'Data Inserimento',
      colAlignment: 'center',
      colWidth: 120

    },
    {
      type: 'campo',
      dataField: 'CodContatto',
      colVisible: true,
      disabled: true,
      readonly: true,
      disableOnUpdate: true,
      showDropDownButton: false,
      class: 'disabileVisibile pe-none',
      dataType: 'string',
      caption: 'Contatto',
      colAlignment: 'left',
      width: 250,
      lista: {
        dataSource: 'contatti',
        valueExpr: 'Cod',
        displayExpr: 'RagSoc',
        Async: true,
        isMultiple: false,
        searchEnable: true,
        showSelectionControls: true,
        settingList: {
          scrollingEnabled: true,
          selectionMode: 'single',
          showSelectionCheckBox: false,
          showScrollbar: 'onHover',
          keyExpr: 'Cod',          
        }
      }
    },
    {
      type: 'campo',
      dataField: 'Descrizione',
      colVisible: true,
      dataType: 'string',
      caption: 'Richiesta',
      allowEditing: true,
      colAlignment: 'left',
      colWidth: 450
    },
    {
      type: 'campo',
      dataField: 'Stato',
      colVisible: true,
      visible: false,
      dataType: 'number',
      caption: 'Stato',
      colAlignment: 'left',
      width: 150,
      lista: {
        dataSource: 'statiDiarioNoChiuso',
        displayExpr: 'value',
        valueExpr: 'key',
        static: true,
        costantValues: [],
        isDefaultOption: false,
      }
    },
  ]
}]